<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-body-1">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        <div class="row">
          <div class="col">
            <v-text-field
              label="Title*"
              :rules="titleRules"
              v-model="data.Title"
              required
              return-object
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field v-model="data.ISBN" label="ISBN"></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.Publisher"
              label="Publisher"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.PublishedYear"
              label="Published Year"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.CityOfPublication"
              label="City Of Publication"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.CountryOfPublication"
              label="Country Of Publication"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.keywords"
              label="keywords"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.listprice"
              label="list price"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.discount"
              label="discount"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.countries_allowed"
              label="countries allowed"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field v-model="data.bisac" label="bisac"></v-text-field>
          </div>
          <div class="col">
            <v-text-field v-model="data.lcc" label="lcc"></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field v-model="data.dewey" label="dewey"></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.language"
              label="language"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole1"
              label="contributor Role 1"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor1"
              label="contributor 1"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole2"
              label="contributor Role 2"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor2"
              label="contributor 2"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole3"
              label="contributor Role 3"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor3"
              label="contributor3"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole4"
              label="contributorRole4"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor4"
              label="contributor4"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole5"
              label="contributorRole5"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor5"
              label="contributor5"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole6"
              label="contributorRole6"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor6"
              label="contributor6"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole7"
              label="contributorRole7"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor7"
              label="contributor7"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole8"
              label="contributorRole8"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor8"
              label="contributor8"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole9"
              label="contributorRole9"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor9"
              label="contributor9"
            ></v-text-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <v-text-field
              v-model="data.contributorRole10"
              label="contributorRole10"
            ></v-text-field>
          </div>
          <div class="col">
            <v-text-field
              v-model="data.contributor10"
              label="contributor10"
            ></v-text-field>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>

        <v-btn @click.native="cancel" v-if="!options.noconfirm"> Cancel </v-btn>
        <v-btn color="primary" @click.native="Save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import * as api from "@/api";

export default {
  name: "ImportPublicationDialog",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "primary",
        width: 700,
        zIndex: 200,
        noconfirm: false,
      },
      data: {},
      titleRules: [(v) => !!v || "Title is required"],
      summaryRules: [
        (v) => !!v || "Summary is required",
        (v) =>
          (v && v.length <= 2000) ||
          "Summary must be less than 2000 characters",
      ],
    };
  },
  methods: {
    open(title, message, options, data) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.data = data;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    Save() {
      //this.resolve(true);
      //this.dialog = false;

      console.log(this.data);

      new Promise((resolve, reject) => {
        api
          .update("import/onix/metadata", this.data)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              this.resolve(true);
              this.dialog = false;
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ImportPublicationDialog.vue